import { isAdmin } from "@/utils/utils";
import axiosConfig from "../../config/axios";

export const getCategories = () => {
  return axiosConfig({
    url: `/categories/`,
    method: "GET"
  });
};

export const getCategory = categoryID => {
  return axiosConfig({
    url: `/categories/${categoryID}/`,
    method: "GET"
  });
};

export const postAttachments = payload => {
  return axiosConfig({
    url: `/attachments/`,
    method: "POST",
    data: payload
  });
};

export const postCategory = payload => {
  return axiosConfig({
    url: `/categories/`,
    method: "POST",
    data: payload
  });
};

export const patchCategory = (categoryID, payload) => {
  return axiosConfig({
    url: `/categories/${categoryID}/`,
    method: "PATCH",
    data: payload
  });
};

export const postCheckList = (categoryID, payload) => {
  return axiosConfig({
    url: `/categories/${categoryID}/checklists/`,
    method: "POST",
    data: payload
  });
};

export const patchCheckList = (categoryID, checkListID, payload) => {
  return axiosConfig({
    url: `/categories/${categoryID}/checklists/${checkListID}/`,
    method: "PATCH",
    data: payload
  });
};

export const deleteCheckList = (categoryID, checkListID) => {
  return axiosConfig({
    url: `/categories/${categoryID}/checklists/${checkListID}/`,
    method: "DELETE"
  });
};

export const deleteCategoryAttachment = (categoryID, attachmentID) => {
  return axiosConfig({
    url: `/categories/${categoryID}/attachments/${attachmentID}/`,
    method: "DELETE"
  });
};

export const deleteChecklistOption = (categoryID, checkListID, payload) => {
  return axiosConfig({
    url: `/categories/${categoryID}/checklists/${checkListID}/options/`,
    method: "DELETE",
    data: payload
  });
};

export const deleteCategory = categoryID => {
  return axiosConfig({
    url: `/categories/${categoryID}/`,
    method: "DELETE"
  });
};
// export const patchCategoryAttachment = (categoryID, checkListID, payload) => {
//   return axiosConfig({
//     url: `/categories/${categoryID}/checklists/${checkListID}/`,
//     method: "PATCH",
//     data: payload,
//   });
// };

export const postCategoryAttachment = (categoryID, payload) => {
  return axiosConfig({
    url: `/categories/${categoryID}/attachments/`,
    method: "POST",
    data: payload
  });
};

export const getCategoryForms = categoryID => {
  return axiosConfig({
    url: `/categories/${categoryID}/forms/`,
    method: "GET"
  });
};

export const getIntakeCategories = () => {
  return axiosConfig({
    url: `/categories`,
    method: "GET"
  });
};

export const getTips = () => {
  return axiosConfig({
    url: `/resources/tips/`,
    method: "GET"
  });
};

export const deleteTip = tip_id => {
  return axiosConfig({
    url: `/resources/tips/${tip_id}/`,
    method: "DELETE"
  });
};

export const postTip = payload => {
  return axiosConfig({
    url: `/resources/tips/`,
    method: "POST",
    data: payload
  });
};

export const getTaskStatus = () => {
  return axiosConfig({
    url: `/task-status/?ordering=title`,
    method: "GET"
  });
};

export const getCapacity = () => {
  return axiosConfig({
    url: `/capacity-planner/`,
    methods: "get"
  });
};

export const postDraftCapacity = payload => {
  return axiosConfig({
    url: `/capacity-planner/`,
    method: "POST",
    data: payload
  });
};

export const getCustomerTaskBoard = (profileId, params) => {
  return axiosConfig({
    // url: `/customers/${profileId}/taskboard/?status=${id}&limit=${limit}&offset=${offset}`,
    url: `/customers/${profileId}/taskboard/`,
    params: {
      ordering: "position",
      marked_for_deletion: false,
      ...params,
    },
    method: "GET"
  });
};

export const patchTaskBoard = (taskId, payload) => {
  return axiosConfig({
    url: `/tasks/${taskId}/`,
    method: "PATCH",
    data: payload
  });
};

export const patchTask = (taskID, payload) => {
  return axiosConfig({
    url: `/tasks/${taskID}/`,
    method: "PATCH",
    data: payload
  });
};

export const postTracker = (taskID, payload) => {
  return axiosConfig({
    url: `/tasks/${taskID}/trackers/`,
    method: "POST",
    data: payload
  });
};
export const patchTracker = (taskID, trackerID, payload) => {
  return axiosConfig({
    url: `/tasks/${taskID}/trackers/${trackerID}/`,
    method: "PATCH",
    data: payload
  });
};

export const deleteTaskCategoryChecklist = (taskID, checkListID) => {
  return axiosConfig({
    url: `/tasks/${taskID}/checklists/${checkListID}/`,
    method: "DELETE"
  });
};
export const deleteTaskCategoryChecklistOptions = (
  taskID,
  checkListID,
  payload
) => {
  return axiosConfig({
    url: `/tasks/${taskID}/checklists/${checkListID}/options/`,
    method: "DELETE",
    data: payload
  });
};

export const deleteTaskCategoryAttachment = (taskID, attachmentID) => {
  return axiosConfig({
    url: `/tasks/${taskID}/attachments/${attachmentID}/`,
    method: "DELETE"
  });
};

export const getNotesListByCustomers = (profile_id, limit, offset) => {
  return axiosConfig({
    url: `/customers/${profile_id}/meetingnotes/`,
    method: "GET",
    params: {
      limit: limit,
      offset: offset
    }
  });
};

export const getAllCountries = () => {
  return axiosConfig({
    url: `https://raw.githubusercontent.com/iloveheadrooms/country-state-city/master/lib/country.json`,
    method: "GET"
  });
};

export const getAdminTaskBoard = (profileId, params) => {
  let { created_lte, created_gte } = params
  if ( created_lte === null || created_gte === null) {
    delete params.created_lte
    delete params.created_gte
  }

  return axiosConfig({
    url: `/admins/${profileId}/taskboard/`,
    method: "GET",
    params: {
      ordering: "position",
      marked_for_deletion: false,
      ...params
    }
  });
};

export const getPATaskBoard = (profileId, params) => {
  let { created_lte, created_gte } = params
  if ( created_lte === null || created_gte === null) {
    delete params.created_lte
    delete params.created_gte
  }

  return axiosConfig({
    url: `/assistants/${profileId}/taskboard/`,
    method: "GET",
    params: {
      ordering: "position",
      marked_for_deletion: false,
      ...params
    }
  });
};

export const getSystemNotifications = offset => {
  return axiosConfig({
    url: `/inbox/notifications/all/?offset=${offset}&limit=5`,
    method: "GET"
  });
};

export const markAllAsRead = () => {
  return axiosConfig({
    url: `/inbox/notifications/mark-all-as-read/`,
    method: "GET"
  });
};

export const getUnreadNotificationCount = () => {
  return axiosConfig({
    url: `/inbox/notifications/unread_count/`,
    method: "GET"
  });
};

export const deleteNotifications = id => {
  return axiosConfig({
    url: `/inbox/notifications/${id}/`,
    method: "DELETE"
  });
};
export const patchTaskChecklist = (taskId, checklistId, payload) => {
  return axiosConfig({
    url: `tasks/${taskId}/checklists/${checklistId}/`,
    method: "PATCH",
    data: payload
  });
};

export const getTeam = params => {
  return axiosConfig({
    url: `/teams/`,
    method: "GET",
    params: {
      ordering: "user__first_name",
      is_active: true,
      ...params
    }
  });
};

export const getTeamPaginated = params => {
  return axiosConfig({
    url: `/teams/`,
    method: "GET",
    params: {
      ordering: "user__first_name",
      is_active: true,
      ...params
    }
  });
};

export const bulkDelete = (profileId, params) => {
  return axiosConfig({
    url: `/assistants/${profileId}/taskboard/bulk-actions/`,
    params,
    method: 'DELETE'
  })
}

export const bulkArchive = (profileId, params) => {
  return axiosConfig({
    url: `/assistants/${profileId}/taskboard/bulk-actions/`,
    params,
    data: {
      action: 'archive'
    },
    method: 'POST'
  })
}
export const bulkArchiveCustomerBoard = (profileId, params) => {
  return axiosConfig({
    url: `/customers/${profileId}/taskboard/bulk-actions/`,
    params,
    data: {
      action: 'archive'
    },
    method: 'POST'
  })
}

export const bulkDeleteCustomerBoard = (profileId, params) => {
  return axiosConfig({
    url: `/customers/${profileId}/taskboard/bulk-actions/`,
    params,
    method: 'DELETE'
  })
}

// test comment
export const getTasks = params => {
  return axiosConfig({
    url: `/tasks/`,
    params,
    method: 'GET'
  })
}

// test comment
export const getTrackers = (createdFor, limit, minDate, maxDate, creator) => {
  return axiosConfig({
    url: `/trackers/`,
    params: {
      created_for: createdFor,
      limit: limit,
      start_at_gte: minDate,
      stop_at_lte: maxDate,
      creator: creator
    },
    method: "GET"
  })
}

export const searchTasks = params => {
  let searchText = params.search.toLowerCase()
  delete params.search
  if (isAdmin()) {
    delete params.assigned_to
  }
  return axiosConfig({
    url: `/search/tasks/`,
    params: {
      ...params,
      deep_search__contains: searchText
    },
    method: 'GET'
  })
};

export const getTaskSuggestionList = () => {
  return axiosConfig({
    url: `/standard-tasks`,
    method: "GET"
  });
};

export const getResourceGroups = () => {
  return axiosConfig({
    url: `resources/groups/`,
    method: "GET"
  });
};

export const postResourceGroup = payload => {
  return axiosConfig({
    url: `resources/groups/`,
    method: "POST",
    data: payload
  });
};

export const updateResourceGroup = (groupId, payload) => {
  return axiosConfig({
    url: `resources/groups/${groupId}/`,
    method: "PATCH",
    data: payload
  });
};

export const reorderGroup = payload => {
  return axiosConfig({
    url: `resources/groups/reorder`,
    method: "POST",
    data: payload
  });
};

export const deleteResourceGroup = groupId => {
  return axiosConfig({
    url: `resources/groups/${groupId}/`,
    method: "DELETE"
  });
};

export const postResourceGroupLink = payload => {
  return axiosConfig({
    url: `resources/links/`,
    method: "POST",
    data: payload
  });
};

export const updateResourceGroupLink = (linkId, payload) => {
  return axiosConfig({
    url: `resources/links/${linkId}/`,
    method: "PATCH",
    data: payload
  });
};

export const reorderGroupLinks = payload => {
  return axiosConfig({
    url: `resources/links/reorder`,
    method: "POST",
    data: payload
  });
};

export const deleteResourceGroupLink = linkId => {
  return axiosConfig({
    url: `resources/links/${linkId}/`,
    method: "DELETE"
  });
};
